export const CK_METHOD_GET = []
export const CK_METHOD_CALL = []
export const CK_METHOD_WATCH = []
export const CK_METHOD_REF = []

export interface $CK_G {}

export interface $CK_C {}

export interface $CK_W {}

export interface $CK_R {}

export interface $CK extends $CK_G, $CK_C, $CK_W, $CK_R {}
